require("@rails/ujs").start()
require("@rails/activestorage").start()
require("channels")
var VueScrollTo = require('vue-scrollto');

import '../stylesheets/application'
import './jquery-3.4.1.js'
import './bootstrap_custom.js'
import './fontawesome.js'
import './serviceworker-companion.js'

import Vue from 'vue/dist/vue.esm';
import axios from 'axios'
import * as VueGoogleMaps from "vue2-google-maps"
import BackToTop from 'vue-backtotop'
import VueSocialSharing from 'vue-social-sharing'
import VModal from 'vue-js-modal'
import InfiniteLoading from 'vue-infinite-loading';
import VueLazyload from 'vue-lazyload'
import VueCookies from 'vue-cookies'
Vue.use(require('vue-cookies'))

// or with options
const loadimage = require('../images/loader.gif')
const errorimage = require('../images/image-placeholder.jpg')
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
Vue.use(VueToast);

Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: errorimage,
  loading: loadimage,
  attempt: 1
})

Vue.use(InfiniteLoading, { /* options */ });
Vue.use(VueScrollTo,{
    container: "body",
    duration: 300,
    easing: "ease",
    offset: 0,
    force: true,
    cancelable: true,
    onStart: false,
    onDone: false,
    onCancel: false,
    x: false,
    y: true
})
Vue.use(VModal)
Vue.use(VueSocialSharing);
Vue.use(BackToTop)
Vue.use(VueGoogleMaps, {
    load: { 
        key: 'AIzaSyBKcK6P6myK7C-C_RX3FJxkPHhkVLtwpdg',
        libraries: 'places', 
    },
    installComponents: true
});

Vue.prototype.$http = axios

import ExampleComponent from '../components/web/exampleComponent.vue'
import NewFilter from '../components/web/newFilter.vue'
import BestDeals from '../components/web/bestDeals.vue'
import ShareBtn from '../components/web/shareBtn.vue'
import BlogsFilter from '../components/web/blogsFilter.vue'
import ReCaptcha from '../components/web/reCaptcha.vue'
import NewlaunchBanner from '../components/web/NewLaunch/newlaunchBanner.vue'
import PhotoSlider from '../components/web/NewLaunch/photoSlider.vue'
import FloorplanSlider from '../components/web/NewLaunch/floorplanSlider.vue'
import UnitConversion from '../components/web/Calculator/unitConversion.vue'
import LoanChecker from '../components/web/Calculator/loanChecker.vue'
import PropertyROI from '../components/web/Calculator/propertyROI.vue'
import TenancyAgreement from '../components/web/Calculator/tenanAgree.vue'
import LawyerStampDuty from '../components/web/Calculator/lawStampDuty.vue'
import RPGT from '../components/web/Calculator/RPGT.vue'
import HomeLoan from '../components/web/Calculator/homeLoan.vue'
import CalGroup from '../components/web/Calculator/calGroup.vue'
import TopValue from '../components/web/Property/topValue.vue'
import ImgLightbox from '../components/web/Property/imgLightbox.vue'
import StaticMap from '../components/web/Property/staticMap.vue'
import PropHighlight from '../components/web/Property/propHighlight.vue'
import TransactedProp from '../components/web/Property/transactedProp.vue'
import SimilarProps from '../components/web/Property/similarProps.vue'
import ContactForm from '../components/web/Property/contactForm.vue'
import AgentListing from '../components/web/Agent/agentListing.vue'
import ListProp from '../components/web/Agent/listProp.vue'
import FindProp from '../components/web/Agent/findProp.vue'
import AgentDesc from '../components/web/Agent/agentDesc.vue'
import AgentList from '../components/web/Agent/agentList.vue'
import PropertyDataLayer from '../components/web/Property/propertyDateLayer.vue'
import LazyImg from '../components/web/lazyImg.vue'
import PasswordForm from '../components/web/user/passwordForm.vue'
import AccountForm from '../components/web/user/accountForm.vue'
import AccountTab from '../components/web/user/accountTab.vue'
import WatchList from '../components/web/user/watchList.vue'
import WatchListButton from '../components/web/user/watchlistButton.vue'
import OutdatedListingModal from '../components/web/Property/outdatedListingModal.vue'
import LoginModal from '../components/web/login.vue'
import ComparisonBtn from "../components/web/Comparison/btn.vue";
import ComparisonList from "../components/web/Comparison/list.vue";
import PropertyMatchingForm from "../components/web/user/propertyMatchingForm.vue";
import CtaModal from '../components/web/ctaModal.vue'
import PropertyMatchingCtaModal from '../components/web/propertyMatchingCtaModal.vue'
import ListingWrapper from '../components/web/listingWrapper.vue'

Vue.component('example-component', ExampleComponent)
Vue.component('new-filter', NewFilter)
Vue.component('best-deals', BestDeals)
Vue.component('newlaunch-banner', NewlaunchBanner)
Vue.component('photo-slider', PhotoSlider)
Vue.component('floorplan-slider', FloorplanSlider)
Vue.component('blogs-filter', BlogsFilter)
Vue.component('re-captcha', ReCaptcha)
Vue.component('share-btn', ShareBtn)
Vue.component('cal-conversion', UnitConversion)
Vue.component('cal-loanchecker', LoanChecker)
Vue.component('cal-roi', PropertyROI)
Vue.component('cal-tenanagree', TenancyAgreement)
Vue.component('cal-lawyersd', LawyerStampDuty)
Vue.component('cal-rpgt', RPGT)
Vue.component('cal-homeloan', HomeLoan)
Vue.component('cal-group', CalGroup)
Vue.component('top-value', TopValue)
Vue.component('img-lightbox', ImgLightbox)
Vue.component('prop-highlight', PropHighlight)
Vue.component('transacted-prop', TransactedProp)
Vue.component('similar-props', SimilarProps)
Vue.component('contact-form', ContactForm)
Vue.component('agent-listing', AgentListing)
Vue.component('static-map', StaticMap)
Vue.component('list-prop', ListProp)
Vue.component('find-prop', FindProp)
Vue.component('agent-desc', AgentDesc)
Vue.component('agent-list', AgentList)
Vue.component('property-data-layer', PropertyDataLayer)
Vue.component('lazy-img', LazyImg)
Vue.component('password-form', PasswordForm)
Vue.component('account-form', AccountForm)
Vue.component('watch-list', WatchList)
Vue.component('watch-list-button', WatchListButton)
Vue.component('account-tab', AccountTab)
Vue.component('outdated-listing-modal', OutdatedListingModal)
Vue.component('login-modal', LoginModal)
Vue.component('comparison-btn', ComparisonBtn);
Vue.component('comparison-list', ComparisonList);
Vue.component('property-matching-form', PropertyMatchingForm);
Vue.component('cta-modal', CtaModal);
Vue.component('property-matching-cta-modal', PropertyMatchingCtaModal);
Vue.component('listing-wrapper', ListingWrapper);


window.addEventListener('load', function () {
    var app = new Vue({
        el: '#app'
    })

    // Hide Header on on scroll down
    var didScroll;
    var lastScrollTop = 0;
    var delta = 5;
    var navbarHeight = 72;
    var $window = $(window);

    $window.scroll(function() {
        didScroll = true;
    });

    setInterval(function() {
        if (didScroll) {
            hasScrolled();
            didScroll = false;
        }
    }, 250);

    function hasScrolled() {
        var st = $(document).scrollTop();
        // $window.height() = 812px for iphone X <- device height
        // $(document).height() = 1644px <- body height
        // Make sure they scroll more than delta
        if(Math.abs(lastScrollTop - st) <= delta)
            return;
        
        // If they scrolled down and are past the navbar, add class .nav-up.
        // This is necessary so you never see what is "behind" the navbar.
        if (st > lastScrollTop && st > navbarHeight/2){
            // Scroll Down
            if($(document).scrollTop() > 250) {
                $('#top-nav').addClass('nav-up');
                $('#filter-m-top').addClass('filter-up');
                $('#filter-m-loc').addClass('loc-up');
            }
        } else {
            // Scroll Up
            if(st + $window.height() < $(document).height()) {
              $('#filter-m-top').removeClass('filter-up');
              $('#filter-m-loc').removeClass('loc-up');
            }
        }
        
        lastScrollTop = st;
    }

    function onReady(callback) {
        var intervalId = window.setInterval(function() {
            if (document.getElementsByTagName('body')[0] !== undefined) {
                window.clearInterval(intervalId);
                callback.call(this);
            }
        }, 1000);
    }
      
    function setVisible(selector, visible) {
        document.querySelector(selector).style.display = visible ? 'block' : 'none';
    }
      
    onReady(function() {
        setVisible('#app', true);
        setVisible('#loading', false);
    });
    
    $("#share-modal").appendTo("#app");

    $(document).ready(function(){
        $('[data-toggle="tooltip"]').tooltip();
    });

    $(document).scroll(function() {
        if ($(document).width() < 991) {
            if($(document).scrollTop() > 400) {
                $("#filter-explore-btn").css("bottom", "30px")
            }else {
                $("#filter-explore-btn").css("bottom", "-50px")
            }
        } else {
            $("#filter-explore-btn").css("display", "none")
        }

        if($(document).scrollTop() > 250) {
            $('#filter-m-top').removeClass('filter-margin');
            $('#filter-m-loc').removeClass('loc-margin');
        } else {
            $('#top-nav').removeClass('nav-up');
            $('#filter-m-top').addClass('filter-margin');
            $('#filter-m-loc').addClass('loc-margin');
        }

        if($(document).scrollTop() > 120) {
            setTimeout(function(){
                $('#agent-profile-img').addClass('img-small');
            },100);
        }else {
            setTimeout(function(){
                $('#agent-profile-img').removeClass('img-small');
            },100);
        }

        if (document.querySelector('.details-propnav')) {
            $('.details-section').each(function(i) {
                if ($window.scrollTop() >= $(this).offset().top - 1) {
                    $('.prop-nav-item.active').removeClass('active');
                    $('.prop-nav-item').eq(i).addClass('active');
                }
            });
        }
    });

    $("#prop-agent-card-btn").click(function(){ $("#propshow-agent-card").slideToggle(); });
    $("#prop-agent-card-x-btn").click(function(){ $("#propshow-agent-card").slideToggle(); });
    $("#details-search").click(function(){ $("#details-trending").slideToggle(); });
    $("#details-trend-pop-x").click(function(){ $("#details-trending").slideToggle(); });
    $("#details-trend-pop-x-2").click(function(){ $("#details-trending").slideToggle(); });
    $("#details-hotarea-pop").click(function(){ $("#details-hot-area").slideToggle(); });
    $("#details-hotarea-pop-x").click(function(){ $("#details-hot-area").slideToggle(); });
    $("#details-hotarea-pop-x-2").click(function(){ $("#details-hot-area").slideToggle(); });

    $("#search-props").submit(function( event ) {
        event.preventDefault();
        $("#details-trending").slideToggle();
    });

    $("#view-password").click(function(){ 
        document.getElementById("sign-password").type = 'text';
        $('#view-password').addClass('d-none');
        $('#hide-password').removeClass('d-none');
    });
    $("#hide-password").click(function(){ 
        document.getElementById("sign-password").type = 'password'; 
        $('#hide-password').addClass('d-none');
        $('#view-password').removeClass('d-none');
    });

    $('.award-read-more').click(function(e){
        e.preventDefault();
        const target = $(this).attr('data-toggle');
        if($(`.${target}`).hasClass('active')) {
            $(this).html('Read more');
        }
        else {
            $(this).html('Read less');
        }
        $(`.${target}`).toggleClass('active');
    })

    // Add the following code if you want the name of the file appear on select
    $("#file-upload").on("change", function() {
        var fileName = $(this).val().split("\\").pop();
        $(".custom-file-upload").addClass("file-selected").html(fileName);
    });

    if ( localStorage.getItem("color-mode") === "light" ) {
        document.documentElement.setAttribute("color-mode", "light");
    } else {
        document.documentElement.setAttribute("color-mode", "dark");
    }

    const toggleColorMode = e => {
        // Switch to Dark Mode
        if (e.currentTarget.classList.contains("dark--hidden")) {
            // Sets the custom html attribute
            document.documentElement.setAttribute("color-mode", "dark");

            // Sets the user's preference in local storage
            localStorage.setItem("color-mode", "dark");
            return;
        }

        // Switch to Light Mode
        // Sets the custom html attribute
        document.documentElement.setAttribute("color-mode","light");

        // Sets the user's preference in local storage
        localStorage.setItem("color-mode","light");
    };

    // Get the buttons in the DOM
    const toggleColorButtons = document.querySelectorAll(".color-mode__btn");

    // Set up event listeners
    toggleColorButtons.forEach(btn => {
        btn.addEventListener("click", toggleColorMode);
    });

});
